import { useSearchParams, useLocation } from 'react-router-dom';
import SiteInspectionChecklistContent from '../components/SiteInspectionChecklistContent';

export default function SiteInspectionChecklistPreview() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const applicationId = searchParams.get('applicationId') || '';
  const legacyBuildingId = searchParams.get('buildingId') || '';
  const stateBid =
    location.state && location.state.internalBuildingId != null
      ? String(location.state.internalBuildingId)
      : '';
  const initialBuildingId = legacyBuildingId || stateBid;

  return (
    <SiteInspectionChecklistContent
      variant="page"
      defaultApplicationId={applicationId}
      defaultBuildingId={initialBuildingId}
      defaultJobId={searchParams.get('jobId') || ''}
      defaultSsCode={searchParams.get('ssCode') || ''}
      defaultSituationKey={searchParams.get('situationKey') || 'FIRST_VISIT'}
    />
  );
}
